import React, { useMemo } from 'react';
import PropTypes from 'prop-types';

import { FlexBoxColumn } from '@ecp/common/src/layouts/flex/styled';
import { Spacing } from '@ecp/common/src/layouts/Spacing';
import { TextBox } from '@ecp/common/src/text/TextBox';

import { ContentTitle } from '@bo-components/common/styled';
import Form from '@bo-components/common/form/Form';
import FormField from '@bo-components/common/form/FormField';

const ClientInfo = ({ siteBasicInfo, subsidiaryList }) => {
  const clientTel = useMemo(
    () =>
      siteBasicInfo.clientRepresentativeTel01
        ? `${siteBasicInfo.clientRepresentativeTel01}-${siteBasicInfo.clientRepresentativeTel02}-${siteBasicInfo.clientRepresentativeTel03}`
        : '',
    [siteBasicInfo]
  );
  const subsidiaries = useMemo(
    () =>
      subsidiaryList
        .map(
          ({ subsidiaryCompanyCode, subsidiaryCompanyName }) => `[${subsidiaryCompanyCode}] ${subsidiaryCompanyName}`
        )
        .join(', '),
    [subsidiaryList]
  );

  return (
    <FlexBoxColumn width={'100%'} align-items={'flex-start'}>
      <ContentTitle type={'secondary'} width={'100%'}>
        고객사정보
      </ContentTitle>
      <Spacing bottom={'8px'} />
      <Form>
        <FormField label={'고객사명'}>
          <TextBox>{siteBasicInfo.clientName}</TextBox>
        </FormField>
        <FormField label={'사업자번호'}>
          <TextBox>{siteBasicInfo.customerBusinessNumber}</TextBox>
        </FormField>
        <FormField label={'대표자전화번호'}>
          <TextBox>{clientTel}</TextBox>
        </FormField>
        <FormField label={'대표자명'}>
          <TextBox>{siteBasicInfo.clientRepresentativeName}</TextBox>
        </FormField>
        <FormField label={'계열사관리'} full>
          <TextBox>{subsidiaries}</TextBox>
        </FormField>
      </Form>
    </FlexBoxColumn>
  );
};

export default ClientInfo;

ClientInfo.propTypes = {
  siteBasicInfo: PropTypes.object,
  subsidiaryList: PropTypes.arrayOf(PropTypes.object),
};
